module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAAOVJREFUKBWNk80KAVEYhue4g9kRSZokycrKtdhbKKUoinIHslBKKQu3YmctSZKfiGswnqOZOp3mzJyv3jlv8z3PnNU4vu8PyY30HJsBvJNwJokO5Dikg3NkI800aWAjzTWpHysBC7LQpK6NtNSkjo200qR2kpRCWCvSl96ykTaa1EiZLCHEl92UyFOOIPV/i3rw5Rr5KDfs6W4U67CokrcCH+gZE1xh+VLgIz1rgsssnwp8oudMcInlQ4HP9LwJ9ljKfyKcC6Vggl2W15AMejESli8Bmgosb/GMcCCkgXZkS0qxMMsfAiN9HGvC5SwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-close.png
// module id = 364
// module chunks = 0 1 2